<template>
  <div class="row">
    <div :id="pageIndex" class="m-10" v-for="(questions, pageIndex) in pages" :key="pageIndex">
      <div class="survey_details_section row mb-30 pt-10">
        <div class="activity_info_setting_title mb-7">
          {{ activityData.name }}
        </div>
      </div>
      <div :key="index" v-for="(question, index) in questions.filter(que => que.type !== 'SurveyCompletion')">
        <div class="row">
          <div class="col-md-11 p-0">
            <div class="question-section">
              <div v-if="question.type === 'SurveyInstruction' || question.type === 'GPSkin' || question.type === 'ImageCapture'" class="mb-20">
                <div v-if="!question.templateImageUrl">
                  <div class="question_body_11 survey_content mb-10" v-html="prepareQuestion(question.formattedTitle, question.stepSequence)"></div>
                  <div class="survey_heading fs-14" v-html="question.formattedInformation"></div>
                  <div v-if="question.previewImageUrl">
                    <img :src="question.previewImageUrl" alt class="wid300" />
                  </div>
                </div>

                <div v-else>
                  <div class="row p-0">
                    <div class="col-sm-6 col-md-6 col-lg-6 p-0">
                      <div class="question_body_22 survey_content mb-10" v-html="prepareQuestion(question.formattedTitle, question.stepSequence)"></div>
                      <div class="survey_heading fs-14 ccc" v-html="question.formattedInformation"></div>
                      <div v-if="question.previewImageUrl">
                        <img :src="question.previewImageUrl" alt class="wid300" />
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <div class="question_body_33 survey_content mb-10">
                        Template image
                      </div>
                      <div v-if="question.templateImageUrl">
                        <img :src="question.templateImageUrl" alt class="wid300" />
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="question.branchingConfigured">
                  <p class="branching-title">Branching</p>
                  <div class="branching-option" v-if="question.type === 'SurveyInstruction'">
                    <span class="branching-text">Any answer</span>
                    <span class="arrow-division"></span>
                    <span class="branching-text branching-text-left"> {{ findStepSequence(question.nextQuestionId) }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="mb-20">
                <div v-if="question.type == 'Section'" class="group-scoring__container-edit mb-10 group-scoring__container-filled d-flex justify-content-between align-items-center">
                  <span class="color-white fs-14">{{ question.formattedBody }}</span>
                </div>
                <div v-else class="question_body_44 survey_content mb-10" v-html="prepareQuestion(question.formattedBody, question.stepSequence)"></div>
                <div class v-if="question.hasBodyImage">
                  <div class v-for="(img, index) in question.bodyImages" :key="index">
                    <img :src="img.previewImageUrl" alt class="wid300" />
                  </div>
                </div>
                <div class="answer-section">
                  <div class="option-section" v-if="question.type.toLowerCase() === 'boolean'">
                    <div class v-for="(option, index) in question.options" :key="index">
                      <p class="radio-option">
                        <input type="radio" name="boolean_type" disabled class="checkbox_position" />
                        <label v-html="option.formattedBody"></label>
                      </p>
                    </div>
                  </div>
                  <div class="option-section pad-top20" v-if="question.type && question.type.toLowerCase() === 'numberscale'">
                    <div v-if="!question.verticalScale">
                      <div v-if="activityData && activityData.newLayout == true">
                        <div class="row">
                          <div class="pl-10 pr-12 col-md-2">
                            {{ question.minValueLabel }}
                          </div>
                          <ds-slider
                            ref="slider"
                            v-if="question.partitions !== 0"
                            :value="question.minValue"
                            :piecewise="true"
                            direction="horizontal"
                            class="horizontal-vue-slider pt-30 col-md-8"
                            :min="question.minValue"
                            :max="question.maxValue"
                            :disabled="true"
                            :piecewiseLabel="true"
                            :piecewiseStyle="piecewiseStyle"
                            :interval="question.partitions"
                            :piecewiseActiveStyle="piecewiseActiveStyle"
                            :labelActiveStyle="labelActiveStyle"
                          ></ds-slider>
                          <ds-slider ref="slider" v-else :value="question.minValue" direction="horizontal" class="horizontal-vue-slider pt-30 col-md-8" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>

                          <div class="pr-0 col-md-2">
                            {{ question.maxValueLabel }}
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <ds-slider
                          ref="slider"
                          v-if="question.partitions !== 0"
                          :value="question.minValue"
                          :piecewise="true"
                          direction="horizontal"
                          class="horizontal-vue-slider pl-20"
                          :min="question.minValue"
                          :max="question.maxValue"
                          :disabled="true"
                          :piecewiseLabel="true"
                          :piecewiseStyle="piecewiseStyle"
                          :interval="question.partitions"
                          :piecewiseActiveStyle="piecewiseActiveStyle"
                          :labelActiveStyle="labelActiveStyle"
                        ></ds-slider>
                        <ds-slider ref="slider" v-else :value="question.minValue" direction="horizontal" class="horizontal-vue-slider pl-20" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                        <div class="pt-10 scaleLabels">
                          <div class="pull-left">
                            {{ question.minValueLabel }}
                          </div>
                          <div class="pull-right">
                            {{ question.maxValueLabel }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="question.verticalScale">
                      <div class="scaleLabels">
                        {{ question.maxValueLabel }}
                      </div>
                      <ds-slider
                        ref="slider"
                        v-if="question.partitions !== 0"
                        :value="question.minValue"
                        :piecewise="true"
                        direction="vertical"
                        class="vertical-vue-slider pl-20"
                        width="2"
                        :min="question.minValue"
                        :max="question.maxValue"
                        :disabled="true"
                        :piecewiseLabel="true"
                        :piecewiseStyle="piecewiseStyle"
                        :interval="question.partitions"
                        :piecewiseActiveStyle="piecewiseActiveStyle"
                        :labelActiveStyle="labelActiveStyle"
                      ></ds-slider>
                      <ds-slider ref="slider" v-else :value="question.minValue" direction="vertical" class="vertical-vue-slider pl-20" width="2" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                      <div class="scaleLabels" v-if="question.verticalScale">
                        {{ question.minValueLabel }}
                      </div>
                    </div>
                  </div>
                  <div class="option-section pad-top20" v-if="question.type && question.type.toLowerCase() === 'vas'">
                    <div v-if="!question.verticalScale">
                      <div v-if="activityData && activityData.newLayout == true">
                        <div class="row">
                          <div class="col-md-3 pr-10">
                            {{ question.minValueLabel }}
                          </div>
                          <div class="col-md-6">
                            <ds-slider ref="slider" :value="question.minValue" direction="horizontal" class="horizontal-vue-slider" :width="question.restrainLengthValue + 'mm'" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"> </ds-slider>
                            <div class="pt-10 scaleLabels-vas">
                              <span :style="{ 'margin-left': 15 + 'px' }">{{ question.minValue }}</span>
                              <span class="pull-right">{{ question.maxValue }}</span>
                            </div>
                          </div>
                          <div class="col-md-3">
                            {{ question.maxValueLabel }}
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="pt-10 scaleLabels-vas">
                          <div :style="{ 'margin-left': 15 + 'px' }">
                            {{ question.minValueLabel }}
                          </div>
                          <div
                            :style="{
                              'margin-left': question.restrainLengthValue - 10 + 'mm'
                            }"
                          >
                            {{ question.maxValueLabel }}
                          </div>
                        </div>
                        <ds-slider ref="slider" :value="question.minValue" direction="horizontal" class="horizontal-vue-slider pl-20" :width="question.restrainLengthValue + 'mm'" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                        <div class="pt-10 scaleLabels-vas">
                          <div :style="{ 'margin-left': 15 + 'px' }">
                            {{ question.minValue }}
                          </div>
                          <div
                            :style="{
                              'margin-left': question.restrainLengthValue - 10 + 'mm'
                            }"
                          >
                            {{ question.maxValue }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="question.verticalScale">
                      <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ question.maxValue }}</span>
                      <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ question.maxValueLabel }}</span>
                      <ds-slider ref="slider" :value="question.minValue" direction="vertical" class="vertical-vue-slider-vas pl-20" width="2" :height="question.restrainLengthValue + 'mm'" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                      <div class="scaleLabels" v-if="question.verticalScale">
                        <span :style="{ 'margin-left': 30 + 'px' }">{{ question.minValue }}</span>
                        <span :style="{ 'margin-left': 30 + 'px' }">{{ question.minValueLabel }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="option-section pt-20" v-if="question.type.toLowerCase() === 'customscale'">
                    <div v-if="!question.verticalScale">
                      <div v-if="activityData && activityData.newLayout == true">
                        <ds-slider-custom-scale
                          ref="slider"
                          :value="question.formattedLabels[0]"
                          :piecewise="true"
                          width="1"
                          direction="horizontal"
                          class="horizontal-vue-slider pl-20 pt-20 pb-25"
                          :data="question.formattedLabels"
                          :disabled="true"
                          :piecewiseLabel="true"
                          :piecewiseStyle="piecewiseStyle"
                          :piecewiseActiveStyle="piecewiseActiveStyle"
                          :labelActiveStyle="labelActiveStyle"
                        ></ds-slider-custom-scale>
                      </div>
                      <div v-else>
                        <ds-slider
                          v-if="!question.verticalScale"
                          ref="slider"
                          :value="question.formattedLabels[0]"
                          :piecewise="true"
                          width="1"
                          direction="horizontal"
                          class="horizontal-vue-slider pl-20 pt-20 pb-25"
                          :data="question.formattedLabels"
                          :disabled="true"
                          :piecewiseLabel="true"
                          :piecewiseStyle="piecewiseStyle"
                          :piecewiseActiveStyle="piecewiseActiveStyle"
                          :labelActiveStyle="labelActiveStyle"
                        ></ds-slider>
                      </div>
                    </div>

                    <ds-slider v-if="question.verticalScale" ref="slider" :value="question.formattedLabels[0]" :piecewise="true" width="2" direction="vertical" class="vertical-vue-slider pl-20" :data="question.formattedLabels" :disabled="true" :piecewiseLabel="true" :piecewiseStyle="piecewiseStyle" :piecewiseActiveStyle="piecewiseActiveStyle" :labelActiveStyle="labelActiveStyle"></ds-slider>
                  </div>
                  <div class="option-section text-input" v-if="question.type.toLowerCase() === 'text'">
                    <input type="text" class="input-text readonly" placeholder readonly />
                  </div>
                  <div class="option-section" v-if="question.type.toLowerCase() === 'datetime'">
                    <div class="col-sm-3 p-0" v-if="question.showDate">
                      <input type="text" class="input-text readonly" placeholder v-model="question.dateFormat" readonly />
                    </div>
                    <div class="col-sm-3" v-if="question.showTime" :class="{ 'pl-10': question.showDate }">
                      <span v-if="question.timeFormat == '12'">
                        <input type="text" class="input-text readonly" placeholder value="--:-- AM" readonly />
                      </span>
                      <span v-if="question.timeFormat == '24'">
                        <input type="text" class="input-text readonly" placeholder value="--:--" readonly />
                      </span>
                    </div>
                  </div>
                  <div class="option-section" v-if="question.type.toLowerCase() === 'number'">
                    <div class="text-input">
                      <input type="text" class="input-text readonly" placeholder readonly />
                    </div>
                  </div>
                  <div class="option-section" v-if="question.type.toLowerCase() === 'valuepicker'">
                    <div class>
                      <input type="number" class="input-text readonly" placeholder readonly />
                    </div>
                  </div>
                  <div class="option-section" v-if="question.type.toLowerCase() === 'email'">
                    <div class>
                      <input type="email" class="input-text readonly" placeholder readonly />
                    </div>
                  </div>
                  <div class="option-section" v-if="question.type.toLowerCase() === 'location'">
                    <div class>
                      <input type="text" class="input-text readonly" placeholder readonly />
                    </div>
                  </div>
                  <div class="option-section" v-if="question.type.toLowerCase() === 'multichoice'">
                    <div v-if="question.subType.toLowerCase() === 'multi'">
                      <div class v-for="(option, index) in question.options" :key="index">
                        <label>
                          <input type="checkbox" class="checkbox_position" disabled />
                          <span class="display-inline" v-html="option.formattedBody"></span>
                        </label>
                        <div class v-if="option.previewImageUrl">
                          <img :src="option.previewImageUrl" alt />
                        </div>
                      </div>
                      <OtherOption :question="question" v-if="question.otherOptionContentField" />
                    </div>
                    <div v-if="question.subType.toLowerCase() === 'single'">
                      <div class v-for="(option, index) in question.options" :key="index">
                        <label>
                          <input type="radio" name="single" disabled class="checkbox_position" />
                          <span class="display-inline" v-html="option.formattedBody"></span>
                        </label>
                        <div class v-if="option.previewImageUrl">
                          <img :src="option.previewImageUrl" alt class />
                        </div>
                      </div>
                      <OtherOption :question="question" v-if="question.otherOptionContentField" />
                    </div>
                  </div>
                  <div class="option-section lang-img-options" v-if="question.type.toLowerCase() === 'image'">
                    <div>
                      <div class="row justify-content-start">
                        <div class="col-auto pl-0 pr-0" v-for="(langOptionobj, loopIndex) in question.languageImageOptions" :key="loopIndex">
                          <div class="language-name">
                            {{ langOptionobj.languageName }}
                          </div>
                          <div class="form-group clearfix" v-for="(option, optionIndex) in langOptionobj.options" :key="optionIndex">
                            <!-- <div v-if="option.enabled"> -->
                            <span v-if="question.subType.toLowerCase() == 'multi'">
                              <input type="checkbox" id="checkbox" disabled class="checkbox_position" />
                            </span>
                            <span v-else>
                              <input type="radio" id="radio" disabled class="checkbox_position" />
                            </span>
                            <img class="col-lg-2 img-size" :src="option.previewImageUrl" />
                            <!-- </div> -->
                          </div>
                          <OtherOption :question="question" v-if="question.otherOptionContentField" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'dropdown'">
                    <div>
                      <div class v-for="(option, index) in question.options" :key="index">
                        <label>
                          <input type="radio" name="single" disabled />
                          <span class="display-inline" v-html="option.formattedBody"></span>
                        </label>
                        <div class v-if="option.previewImageUrl">
                          <img :src="option.previewImageUrl" alt class />
                        </div>
                      </div>
                      <OtherOption :question="question" v-if="question.otherOptionContentField" />
                    </div>
                    <div class="option-section lang-img-options" v-if="question.type && question.type.toLowerCase() === 'image'">
                      <div>
                        <div class="row justify-content-start">
                          <div class="col-auto pl-0 pr-0" v-for="(langOptionobj, loopIndex) in question.languageImageOptions" :key="loopIndex">
                            <div class="language-name">
                              {{ langOptionobj.languageName }}
                            </div>
                            <div class="form-group clearfix" v-for="(option, optionIndex) in langOptionobj.options" :key="optionIndex">
                              <div>
                                <span v-if="question.subType && question.subType.toLowerCase() === 'multi'">
                                  <input type="checkbox" id="checkbox" disabled />
                                </span>
                                <span v-else>
                                  <input type="radio" id="radio" disabled />
                                </span>
                                <img class="col-lg-2 img-size" :src="option.previewImageUrl" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <branchingLogicQus :question="question" :questions="$store.getters.getActivityQuestionsData" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dsSlider from "../../lib/ds-slider-component";
import dsSliderCustomScale from "@/lib/ds-slider-component-custom-scale";
import * as commonHelper from "@/components/services/common-helper";
import branchingLogicQus from "../activity-library/branching-logic.vue";
import OtherOption from "../../components/study-details/view-links/otherOption.vue";

export default {
  name: "qaCard",
  data() {
    return {
      pages: {},
      selectedQuestion: { id: null },
      selectedQuestionForBranching: { id: null },
      studyId: null,
      activityId: null,
      hideEditBtn: false,
      activityQuestions: [],
      piecewiseActiveStyle: {
        backgroundColor: "#3498db"
      },
      labelActiveStyle: {
        color: "#3498db"
      },
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      }
    };
  },
  components: { dsSlider, dsSliderCustomScale, branchingLogicQus, OtherOption },
  props: {
    activityData: {}
  },
  mounted() {
    this.activityId = this.$route.params.activityId;
  },
  computed: {
    questions() {
      return this.$store.getters.getActivityQuestionsData;
    }
  },
  methods: {
    prepareQuestion(q, i) {
      return i + '. <span style="display: inline-block">' + q + "</span>";
    },
    findStepSequence(nextQuestion) {
      return commonHelper.branchingLogic(nextQuestion, this.questions);
    }
  },
  watch: {
    questions: {
      handler(val) {
        this.activityQuestions = val;

        this.pages = {};
        let pageIndex = 0;
        const SIZE = 3;
        let currentQuestionCount = 0;
        let pageId;

        this.pages[pageId] = [];

        for (let i = 0, seq = 1; i < this.activityQuestions.length; i++) {
          if (this.activityQuestions[i].type && this.activityQuestions[i].type != "Section") {
            this.activityQuestions[i].stepSequence = seq++;
          }

          if (((currentQuestionCount == 0 && this.pages[pageId].length == 0) || currentQuestionCount > SIZE) && this.activityQuestions[i].type != "SurveyCompletion") {
            pageId = "page-" + pageIndex;
            pageIndex++;
            this.pages[pageId] = [];
            currentQuestionCount = 0;
          }

          if (this.activityQuestions[i].type != "Section") {
            currentQuestionCount++;
          }
          this.pages[pageId].push(this.activityQuestions[i]);
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
h1,
h2,
h3 {
  font-weight: 200;
}
.wid300 {
  max-width: 120px;
  max-height: 120px;
}
.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}
.display-inline {
  display: inline-block;
  padding-left: 5px;
}
/deep/ .vue-slider-component .vue-slider-tooltip {
  display: none;
}
.read_only_question {
  border-left: 8px solid #d3dfe4 !important;
  background-color: #f5f8fa;
}

.icon-style {
  color: #57dd7a;
  font-size: 25px;
  padding-top: 20px;
  background-color: #d6f0de;
  padding: 7px;
  padding-bottom: 3px;
  border-radius: 25px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

// Style for quick fixes bootstrap after migration (before redesign should be removed)

.option-section {
  &:after {
    content: "";
    clear: both;
    display: block;
  }
  .col-sm-3 {
    float: left;
  }
  label {
    word-break: break-word !important;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

h1,
h2,
h3 {
  font-weight: 200;
}

.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}

.question_body {
  word-break: break-all;
  color: #959fa4;
}

.read_only_question {
  border-left: 8px solid #d3dfe4 !important;
  background-color: #f5f8fa;
}

.icon-style {
  color: #57dd7a;
  font-size: 25px;
  padding-top: 20px;
  background-color: #d6f0de;
  padding: 7px;
  padding-bottom: 3px;
  border-radius: 25px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

.text-style {
  color: #969090;
  text-align: right;
}

.btn-style {
  margin-top: 10px;
  width: 80px;
  height: 29px;
  margin-bottom: 50px;
}

.custom-btn {
  background: #00baf9;
  color: #fff;
  width: 220px;
}

.pad-top50 {
  padding-top: 50px;
}

.form-control {
  border-radius: 2px;
}

.custom-para {
  padding-bottom: 20px;
  font-size: 20px;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
.readonly {
  background: #f7f7f7;
}
.btn-disabled {
  color: white;
  background-color: #c6c2c2;
  border: #c6c2c2;
}

.text-color {
  color: #888;
}

.survey-name {
  color: #00baf9;
  font-size: 20px;
}

.pad-left50 {
  padding-left: 50px;
}
.branching_section {
  background-color: #f5f8fa;
  border: solid 1px #d3dfe4;
  padding: 5px 10px;
  .branching_image {
    max-width: 120px;
    max-height: 120px;
    width: 100%;
    border: 1px solid #ccc;
  }
}
.custom-btn-bg {
  background: linear-gradient(to left, #4b6fe6, #00baf9);
  color: #fff;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.pad-left100 {
  padding-left: 100px;
}

.mar-bot0 {
  margin-bottom: 0px !important;
}

.card {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 15px;
  margin-bottom: 16px;
}

.question_color,
input {
  color: #666769;
  font-size: 14px;
}

.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}

.input-text {
  width: 100%;
  border-radius: 2px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.date-input {
  border-radius: 20px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.pad-top20 {
  padding-top: 20px;
}

.vertical-vue-slider {
  height: 300px !important;
  width: 4px;
  padding: 11px;
  margin-left: 30px;
}

.horizontal-vue-slider {
  height: 8px;
  width: 100%;
}

.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 120px;
  max-height: 120px;
  padding-left: 5px;
}

label {
  font-weight: normal !important;
  word-break: break-all;
  color: #959fa4;
}

.modal-dialog {
  width: 500px !important;
}

.survey_content {
  color: #666669;
  font-size: 14px;
  font-weight: bold;
  word-break: break-word;
}
.survey_content span p {
  word-break: break-word !important;
}

.survey_heading {
  color: #959fa4;
  font-size: 12px;
}
.survey_heading p {
  word-break: break-word !important;
}

.checkbox_position {
  position: relative;
  top: 2px;
}

.text-input {
  width: 48%;
}

.lang-img-options .col-auto {
  margin-right: 137px !important;
}
.lang-img-options .col-auto:last-of-type {
  margin-right: 0 !important;
}
.language-name {
  color: #666669;
}
.group-scoring__container-edit {
  padding: 2px;
  border-radius: 3px;
  border: solid 1px #b0bac9;
  background-color: #b0bac9;
}
.survey_details_section {
  border-bottom: 2px solid #979797;
  padding-bottom: 20px;
  word-break: break-word !important;
  width: 100%;
  display: flex;
}
.activity_info_setting_tital {
  font-size: 16px;
  font-weight: 600;
  color: #959fa4;
}
.branching-title {
  font-size: 12px;
  line-height: 16px;
  color: #666669;
  font-weight: bold;
  text-decoration: underline;
  margin-top: 14px;
}
.branching-text {
  font-size: 12px;
  line-height: 16px;
  color: #666669;
  margin-right: 12px;
  white-space: pre;
}
.branching-text-val {
  font-size: 12px;
  line-height: 16px;
  color: #666669;
  margin-right: 4px;
  white-space: pre;
}
.branching-text-left {
  margin-left: 6px;
}

.arrow-division {
  height: 1px;
  align-self: stretch;
  flex-grow: 0;
  transform: rotate(-180deg);
  background-color: #666669;
  line-height: 1px;
  padding: 0;
  margin: 0;
  display: flex;
  width: 100%;
  position: relative;
  top: 8px;
}
.branching-option {
  display: flex;
  width: 300px;
  justify-content: space-between;
  margin-bottom: 12px;
}
.branching-range-left {
  display: flex;
}
.multiValue-data {
  display: flex;
  flex-wrap: wrap;
}
.right-step-recursive {
  display: block;
}
</style>
